import { OrderStatus } from "src/api/types";

export const orderStatuses: OrderStatus[] = [
  "canceled",
  "created",
  "delivered",
  "finalized",
  "paid",
  "sent_to_pharmacy",
  "sent_to_pharmacy",
  "shipped",
  "unpaid",
] as const;
